import React, { Component, Fragment } from 'react';
import { Card, CardBody } from 'reactstrap';

import JsonBlockGenerator from '../components/JsonBlockGenerator';

export default class PropertyAmentiesBook extends Component {
  render() {
    return (
      <Fragment>
        <Card>
          <CardBody>
            <JsonBlockGenerator filename={'property_amenities_book.json'} />
          </CardBody>
        </Card>
      </Fragment>
    );
  }
}
